/* Shared animation variants */
// eslint-disable-next-line import/prefer-default-export
export const NavigationVariants = {
  moveIn: {
    x: '0%',
    opacity: 1,
    transition: { duration: 0.3, ease: 'easeOut' }
  },
  moveOutRight: {
    x: '100%',
    opacity: 0,
    transition: { duration: 0.3, ease: 'easeOut' }
  },
  moveOutLeft: {
    x: '-100%',
    opacity: 0,
    transition: { duration: 0.3, ease: 'easeOut' }
  },
  invisible: {
    opacity: 0,
    transition: { duration: 0.6, ease: 'easeOut' }
  },
  visible: {
    opacity: 1,
    transition: { duration: 0.6, ease: 'easeOut' }
  },
  invisibleNoTransition: {
    opacity: 0
  },
  toggleFromTopInvisible: {
    opacity: 0,
    originY: 0,
    scaleY: 0,
    transition: { duration: 0.2 }
  },
  toggleFromTopVisible: {
    opacity: 1,
    originY: 0,
    scaleY: 1,
    transition: { duration: 0.2 }
  },
  toggleFromTopVisibleNoTransition: {
    opacity: 1,
    originY: 0,
    scaleY: 1
  }
};

/* Helper objects for Animations */
export const ANIMATIONSTATES = Object.freeze({
  firstRender: 'FIRSTRENDER',
  inWidget: 'INWIDGET',
  fromHome: 'FROMHOME',
  betweenWidgets: 'BETWEENWIDGETS',
  toHome: 'TOHOME',
  toPopover: 'TOPOPOVER'
});
